<template>
  <div class="flex items-center h-10">
    <svg
      height="32"
      viewBox="0 0 1011 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50 0H0V226H50.5V132.5C52 80.5 126.299 82 126.299 124.5V226H177V120C177 78.5 146 49 104.5 49C82.4158 49 70.4688 53.0121 50 66V0Z"
        fill="#009491"
      />
      <path
        d="M247 54.5H196V156C196 192.5 227 229.5 264 229.5H305C341.5 229.5 371.5 192 371.5 156V54.5H321V151C321 200.5 247 200.5 247 151V54.5Z"
        fill="#009491"
      />
      <path
        d="M546.5 54.5H396.5V98H474L391.5 195V226H551V182H465L546.5 87V54.5Z"
        fill="#009491"
      />
      <path
        d="M721 54.5H571V98H648.5L566 195V226H725.5V182H639.5L721 87V54.5Z"
        fill="#009491"
      />
      <path
        d="M804.5 0H753.5V226H804L804.5 0Z"
        fill="#009491"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M871 154.5H1010.5V134.5C1010.5 109 995.5 85 981.5 72.5C967.5 60 943.5 49 916.5 49C889.5 49 867 57.587 850.5 72.5C834 87.413 827.5 102.927 824 114C820.5 125.073 819.649 135.5 822 154.5C824.351 173.5 834.5 195.1 852.5 209.5C870.5 223.9 888 230 910.5 230H925C955.5 230 995 207 1006 171.5H950.5C941.518 184.938 934.5 190 915.5 190C896.5 190 876.5 176.5 871 154.5ZM957.5 119H873C879.396 100.862 893 89 915.5 89C938 89 951.5 102.5 957.5 119Z"
        fill="#009491"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
